import React from 'react'
import { useSelector } from "react-redux";
import {Heading, SubHeading, Song2} from "./BlockParts/index";

export default function SongBlock2({options,items,idx,settings}) {
  const FontSettings = useSelector((state) => state.project?.fontStyle);
  return (
    <div key={idx} id={"block_" + idx} className="text-[18px] w-full flex flex-col justify-center p-1 overlaytext">
      <Heading options={options} fontStyle={FontSettings?.heading}  idx={idx} />
      <SubHeading options={options} fontStyle={FontSettings?.subHeading} idx={idx} />
      <Song2 options={options}  fontStyle={FontSettings} items={items} idx={idx} settings={settings} />
    </div>
  )
}